import { apiUrl } from 'config';
import UserProfile from "components/UserProfile/UserProfile";
import axios from 'axios';
import toast, { Toaster } from "react-hot-toast"

export const modifySkids = async (modifiedOrderSkidsDict) => {
    const token = await UserProfile.getToken();
    try {
        const response = await axios.put(
            `${apiUrl}admin/skids`,
            modifiedOrderSkidsDict,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        toast.success(response.data.msg);
    }
    catch (error) {
        error.response.data?.msg ? toast.error(error.response.data.msg) : toast.error(error.response.data)
    }
};
